import React, { Component } from 'react';

export default class Sorting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sortingOptions: [
        {
          id: 0,
          option: 'name',
          name: 'Name',
          active: false
        },
        {
          id: 1,
          option: 'rating',
          name: 'Bewertung',
          active: false
        },
        // {
        //   id: 2,
        //   option: 'time',
        //   name: 'Aufwand',
        //   active: false
        // },
        {
          id: 3,
          option: 'count',
          name: 'Häufigkeit',
          active: false
        }
      ],
      up: true
    };
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(optionClicked) {
    const newState = this.state.sortingOptions.map(option => {
      return {
        id: option.id,
        option: option.option,
        name: option.name,
        active: optionClicked === option
      };
    });

    let active = optionClicked.active;
    const up = active ? !this.state.up : true;
    this.setState({
      sortingOptions: newState,
      up: up
    });

    this.props.onClick(optionClicked.option, up);
  }

  render() {
    return (
      <div style={sortStyle}>
        <strong>Sortieren</strong>
        {this.state.sortingOptions.map(option => (
          <div
            style={sortOptionStyle(option.active)}
            onClick={this.handleClick.bind(this, option)}
            key={option.id}
          >
            {option.name}
          </div>
        ))}
      </div>
    );
  }
}

// CSS Styling
const sortStyle = {
  padding: '0.5em 0em',
  paddingLeft: '1em',
  display: 'flex'
};

const sortOptionStyle = state => {
  return {
    marginLeft: '1em',
    cursor: 'pointer',
    textDecoration: state ? 'none' : 'none'
  };
};
